import React from "react";
import { Search } from "lucide-react";

const CategoryFilter = ({
  selectedCategories,
  selectedParentCategory,
  allCategories,
  parentCategories,
  getChildCategories,
  toggleParentCategory,
  toggleCategory,
  isMobile,
  onSearchClick,
  onClearFilters
}) => {
  return (
    <div className="category-filters">
      <div
        className="parent-category-container"
        style={{ display: isMobile ? "none" : "flex" }}
      >
        {Object.keys(parentCategories).map((parentKey) => (
          <button
            key={parentKey}
            className={`parent-category-btn ${
              selectedParentCategory === parentKey ? "active" : ""
            }`}
            onClick={() => toggleParentCategory(parentKey)}
          >
            {parentKey}
          </button>
        ))}
      </div>

      {selectedParentCategory && !isMobile && (
        <div className="category-buttons-desktop expanded">
          {getChildCategories(selectedParentCategory).map(
            ({ category, count }) => (
              <button
                key={category}
                className={`category-btn ${
                  selectedCategories.includes(category) ? "active" : ""
                }`}
                onClick={() => toggleCategory(category)}
              >
                {category} <span className="filter-count">{count}</span>
              </button>
            )
          )}
        </div>
      )}

      {/* Mobile dropdown and search */}
      <div className="mobile-filter-row">
        <select
          className="category-select-mobile"
          value={selectedCategories[0] || ""}
          onChange={(e) => e.target.value ? toggleCategory(e.target.value) : onClearFilters()}
        >
          <option value="">All Categories</option>
          {allCategories.map(({ category, count }) => (
            <option key={category} value={category}>
              {category} ({count})
            </option>
          ))}
        </select>
        <button
          className="search-icon-btn"
          onClick={onSearchClick}
          aria-label="Search items"
        >
          <Search size={20} />
        </button>
      </div>
    </div>
  );
};

export default CategoryFilter;